export default "__VITE_ASSET__4823eb11__"